import request from './base/api';

/**
 * 獲取 方案資訊 API
 * @param {string} programId - 商品的 program_id
 * @param {function} cb - 成功回調
 * @param {function} errCb - 失敗回調
 */
export function fetchCheckoutData(programId, cb, errCb) {
  return request({
    url: `product-plan/${programId}`,
    method: 'get',
    cb,
    errCb
  });
}

/**
 * 取得入會費產品資訊
 * @param {Function} cb 成功回調
 * @param {Function} errCb 錯誤回調
 */
export function fetchMembershipFee(cb, errCb) {
  return request({
    url: 'shopping/membership-fee',
    method: 'get',
    cb,
    errCb
  });
}

/**
 * 建立臨時訂單 API
 * @param {Object} params - 訂單參數
 * @param {Number} params.type - 訂單類型（0: 購物網頁, 1: POS 端）
 * @param {Number} params.member_id - 會員 ID
 * @param {Object} params.cart_details - 購物車詳情
 * @param {Number} params.subtotal - 小計金額
 * @param {Number} params.discount - 折扣金額
 * @param {Number} params.total - 總金額
 * @param {Boolean} params.membership_fee - 是否包含入會費
 * @param {Function} cb - 成功回調
 * @param {Function} errCb - 失敗回調
 */
export function createTemporaryOrder(
  {
    type,
    member_id,
    cart_details,
    subtotal,
    discount,
    total,
    membership_fee,
    discount_code_id
  },
  cb,
  errCb
) {
  const config = {
    data: {
      type,
      member_id,
      cart_details,
      subtotal,
      discount,
      total,
      membership_fee,
      discount_code_id
    }
  };

  return request({
    url: `shopping/temporary-order`,
    method: 'post',
    cb,
    errCb,
    config
  });
}

export default {
  fetchCheckoutData,
  fetchMembershipFee,
  createTemporaryOrder
};
